import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_onNavigateAction1k4uaqqhaf5fe as get_onNavigateAction } from './ExternalLink.mjs';
import { NativeContainerElementWithSecondaryActionpxt1q8w6be21 as NativeContainerElementWithSecondaryAction } from '../InteractiveElement.mjs';
import { ClickableSemantic_getInstance29tidgppnw5x2 as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { externalLinkDriverActions1ec393ucdz1u1 as externalLinkDriverActions } from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { safeLinkUrlOrNulle8yc4vtqk4ie as safeLinkUrlOrNull } from '../../utils/UrlSafety.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerEventListener($this) {
  if ($this.eventListenerAdded_1)
    return Unit_instance;
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
  var this_0 = $this.native_1;
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    tmp0_safe_receiver.addEventListener('click', (it) => {
      var tmp0_safe_receiver = $this.action_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.startAction_u0zgbm_k$($this);
      }
      if (!($this.get_to_kntnng_k$() == null)) {
        var tmp1_safe_receiver = get_onNavigateAction($this);
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.startAction_u0zgbm_k$($this);
        }
      }
      return Unit_instance;
    });
    tmp = Unit_instance;
  }
  if (tmp == null) {
    // Inline function 'kotlin.run' call
    var tmp_0 = this_0.eventsBack_1['on' + 'click'];
    var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    var tmp_1 = 'on' + 'click';
    this_0.eventsBack_1[tmp_1] = (it) => {
      var tmp0_safe_receiver = old;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(it);
      var tmp0_safe_receiver_0 = $this.action_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.startAction_u0zgbm_k$($this);
      }
      if (!($this.get_to_kntnng_k$() == null)) {
        var tmp1_safe_receiver = get_onNavigateAction($this);
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.startAction_u0zgbm_k$($this);
        }
      }
      return Unit_instance;
    };
  }
  $this.eventListenerAdded_1 = true;
}
var ExternalLinkClass;
function ExternalLink() {
  if (ExternalLinkClass === VOID) {
    class $ extends NativeContainerElementWithSecondaryAction() {
      constructor(context) {
        super(context);
        this.set_themeChoice_py59um_k$(this.get_themeChoice_22tyn3_k$().plus_duvq05_k$(ClickableSemantic_getInstance()));
        this.native_1.tag_1 = 'a';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        this.native_1.classes_1.add_utx5q5_k$('clickable');
        this.eventListenerAdded_1 = false;
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), externalLinkDriverActions(this));
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
      set_to_ulc74x_k$(value) {
        this.native_1.setAttribute_j9pxft_k$('href', safeLinkUrlOrNull(value));
      }
      get_to_kntnng_k$() {
        // Inline function 'com.lightningkite.kiteui.views.href' call
        var tmp = this.native_1.attributes_1.native_1.href;
        return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
      }
      set_newTab_2o3mwz_k$(value) {
        this.native_1.setAttribute_j9pxft_k$('target', value ? '_blank' : '_self');
        this.native_1.setAttribute_j9pxft_k$('rel', value ? 'noopener noreferrer' : null);
      }
      nativeSetAction_dc0jqw_k$(action) {
        registerEventListener(this);
        var tmp = this.native_1;
        var tmp0_elvis_lhs = this.get_accessibleLabel_uztlo5_k$();
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          tmp_0 = action == null ? null : action.get_title_iz32un_k$();
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp.setAttribute_j9pxft_k$('aria-label', tmp_0);
      }
      nativeSetSecondaryAction_hwk8oa_k$(action) {
        registerEventListener(this);
      }
    }
    initMetadataForClass($, 'ExternalLink');
    ExternalLinkClass = $;
  }
  return ExternalLinkClass;
}
function ExternalLink$_get_secondaryAction_$ref_wjn1cn() {
  return constructCallableReference((p0) => p0.secondaryAction_1, 1, 0, 81);
}
function ExternalLink$_set_secondaryAction_$ref_j8wsgb() {
  return constructCallableReference((p0, p1) => {
    p0.set_secondaryAction_uet0qs_k$(p1);
    return Unit_instance;
  }, 2, 0, 82);
}
//region block: exports
export {
  ExternalLink as ExternalLink3fl954ixvn5zt,
  ExternalLink$_get_secondaryAction_$ref_wjn1cn as ExternalLink$_get_secondaryAction_$ref_wjn1cn2ikrpddjhr86y,
  ExternalLink$_set_secondaryAction_$ref_j8wsgb as ExternalLink$_set_secondaryAction_$ref_j8wsgb3b5sm5zjlt525,
};
//endregion

//# sourceMappingURL=ExternalLink.commonHtml.mjs.map
